<header class="headerTitle">
  <h5>{{ 'Sellers.Bill_Payment.Bill_Payments' | translate}} </h5>
  <i class="fas fa-chevron-right"></i>
  <h5><a (click)="back()">{{ 'Sellers.Bill_Payment.Categories' | translate}}</a></h5>
  <i class="fas fa-chevron-right"></i>
  <h5 *ngIf="category">{{category.name}}</h5>
  <button class="fas fa-arrow-circle-left btn-back" type="button" (click)="back()"></button>
</header>
<div>

  <app-card-item-list [items]="providers" (onItemClicked)="onClickProvider($event)" [ListHeader]="'Providers'">

  </app-card-item-list>

  <router-outlet>

  </router-outlet>
</div>
